var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackageGcadviceSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23.644c0 .165-3.038.356-6.54.356-3.5 0-6.338-.133-6.338-.298 0-.165 2.838-.298 6.339-.298 3.5 0 6.539.076 6.539.24z",
    fill: "#32323F",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.711 0c3.622.008 6.549 5.296 6.536 11.813-.012 6.516-1.975 11.807-6.904 11.807-2.9 0-6.226-5.318-6.213-11.834C.142 5.27 3.09-.007 6.711 0z",
    fill: "#7D1300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.172 11.81c-.013 6.517-2.748 11.794-6.109 11.787H6.01a3.17 3.17 0 0 1-.655-.08 3.681 3.681 0 0 1-1.173-.5C1.744 21.475-.01 17.027 0 11.787.012 5.27 2.747-.007 6.108 0c.097 0 .192.005.288.014 3.226.298 5.787 5.468 5.775 11.797z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 5.779 11.799)",
    cx: 5.779,
    cy: 11.799,
    rx: 10.428,
    ry: 5.379
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 5.517 11.799)",
    cx: 5.517,
    cy: 11.799,
    rx: 8.489,
    ry: 4.378
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 5.193 11.798)",
    cx: 5.193,
    cy: 11.798,
    rx: 6.886,
    ry: 3.552
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 4.977 11.798)",
    cx: 4.977,
    cy: 11.798,
    rx: 4.61,
    ry: 2.378
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 4.977 11.798)",
    cx: 4.977,
    cy: 11.798,
    rx: 2.323,
    ry: 1.198
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.416 10.954c-.134.325.273.672.012 1.348-.262.676.75-.866.75-.866l-.292-.762-.47.28z",
    fill: "#CD2B31"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 7.812,
    cy: 11.842,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.477 12.02s.257-.063.255-.137c0-.06-.26-.095-.26-.095l-1.428.104.005.232 1.428-.104z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.142 11.806c-.036-.117-.138-.2-.255-.196l-1.756.065.007.142.02.448 1.755-.065c.141-.005.25-.137.243-.294v-.021a.337.337 0 0 0-.014-.08z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.131 11.676-1.788.139a14.14 14.14 0 0 0-.7.063c-.454.05-.957.129-.956.221v.001c.013.162 1.572.164 1.676.16l1.794.005-.02-.448-.006-.14v-.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.003 12.05-1.828.069a.356.356 0 0 0-.015.022l-.007.011a.782.782 0 0 0 .102.938.62.62 0 0 0 .466.194.61.61 0 0 0 .449-.227l.596-.72.067-.082.17-.204z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.142 11.806c-.036-.117-.138-.2-.255-.196l-1.756.065-1.788.14a14.14 14.14 0 0 0-.7.063l-.036.088 2.53-.15.56-.032s1.143-.03 1.445.021z",
    fill: "#1F1F39",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.616 10.916a.618.618 0 0 1 .467.194l.92.94-1.829.069a.78.78 0 0 1-.006-.975.61.61 0 0 1 .448-.228z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.833 12.331a56.949 56.949 0 0 1-1.673-.19l-.007.02a1.724 1.724 0 0 0-.083.316c.213-.065.453-.056.765-.044.317.013.78.011.93.035l.068-.137z",
    fill: "#1F1F39",
    opacity: 0.18
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackageGcadviceSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-gcadvice-small.1d3f4a492d12432bc78b26c0bfc45317.svg";